import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../api";
import { IDCardFront, IDCardBack } from "../components/IDCardFaces.jsx";

export default function IDCardPrint() {
  const { employeeId } = useParams();
  const [data, setData] = useState(null);
  const [qrCode, setQrCode] = useState(null);
  const [error, setError] = useState("");
  const [printSide, setPrintSide] = useState("both");

  useEffect(() => {
    Promise.all([api.employees.get(employeeId), api.employees.qrCode(employeeId)])
      .then(([emp, qr]) => {
        setData(emp);
        setQrCode(qr.qr_code);
      })
      .catch((e) => setError(e.message));
  }, [employeeId]);

  if (error) return <div className="p-8 text-red-600">{error}</div>;
  if (!data) return <div className="p-8 text-gray-500">Loading…</div>;

  if (!data.photo_approved) {
    return (
      <div className="p-8">
        <p className="text-gray-600 mb-2">This employee's photo has not been approved yet.</p>
        <Link to={`/admin/employees/${employeeId}`} className="underline" style={{ color: "#154E93" }}>Back to profile to approve it</Link>
      </div>
    );
  }

  const displayName = `${data.preferred_name || data.first_name} ${data.last_name}`.trim();
  const photoUrl = `${api.employees.photoUrl(employeeId)}?t=${data.updated_at || ""}`;
  const printNow = (side) => {
    setPrintSide(side);
    window.setTimeout(() => window.print(), 80);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <style>{`
        @page { size: auto; margin: 0.35in; }
        @media print {
          .no-print { display: none !important; }
          html, body { background: white !important; }
          .print-page { box-shadow: none !important; padding: 0 !important; margin: 0 !important; }
          .print-page.side-front .back-card { display: none !important; }
          .print-page.side-back .front-card { display: none !important; }
        }
      `}</style>

      <div className="no-print max-w-3xl mx-auto mb-6 bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h1 className="text-lg font-bold" style={{ color: "#154E93" }}>ID Card — {displayName}</h1>
          <p className="text-xs text-gray-500 mt-1">Standard CR80 size: 3.375 × 2.125 inches. Print at 100% scale.</p>
        </div>
        <div className="flex flex-wrap gap-2">
          <Link to={`/admin/employees/${employeeId}`} className="px-3 py-2 text-sm rounded-lg border">Back</Link>
          <button onClick={() => printNow("front")} className="px-3 py-2 text-sm rounded-lg border" style={{ color: "#154E93", borderColor: "#154E93" }}>Print Front</button>
          <button onClick={() => printNow("back")} className="px-3 py-2 text-sm rounded-lg border" style={{ color: "#154E93", borderColor: "#154E93" }}>Print Back</button>
          <button onClick={() => printNow("both")} className="px-4 py-2 text-sm rounded-lg text-white" style={{ backgroundColor: "#154E93" }}>Print Both</button>
        </div>
      </div>

      <div className={`print-page side-${printSide} max-w-3xl mx-auto bg-white shadow-sm p-8 flex flex-wrap gap-8 justify-center items-start`}>
        <div className="front-card">
          <div className="no-print text-xs font-semibold text-gray-500 mb-2 text-center">FRONT</div>
          <IDCardFront data={data} photoUrl={photoUrl} qrCode={qrCode} displayName={displayName} />
        </div>
        <div className="back-card">
          <div className="no-print text-xs font-semibold text-gray-500 mb-2 text-center">BACK</div>
          <IDCardBack data={data} displayName={displayName} />
        </div>
      </div>
    </div>
  );
}
